import React from "react";
import { Navigate, useLocation } from "react-router";
import { getUserData, validateUserPrivileges } from "../../../service/tenant/SecurityService";
import constants from "../util/Constants";

function RequireAuth( {privileges, children} ){

    const userData = getUserData();
    const location = useLocation();

    //console.debug('[requireAuth] userData: ', userData);
    //console.debug('[requireAuth] privileges: ', privileges);

    

    if( !userData ){
        return <Navigate to={constants.routes.login} state={{from: location}}/>
    }


    const validatePrivileges = validateUserPrivileges(privileges);

    
    if( userData && privileges && !validatePrivileges ){
        return <Navigate to={constants.routes.login} state={{from: location}}/>
    }

    
    
    return children;
}

export default RequireAuth;